module.exports = __webpack_public_path__ + "img/graduation-cap.44db8801.png";